var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.user)?_c('v-btn',{staticClass:"mx-4",attrs:{"icon":"","color":"black lighten-1"},on:{"click":function($event){return _vm.$emit('logout')}}},[_vm._v(" Logout ")]):_c('v-btn',{attrs:{"text":""},on:{"click":function($event){return _vm.$emit('login')}}},[_vm._v(" Login ")])
}
var staticRenderFns = []

export { render, staticRenderFns }